export const taskStateToColor = {
  NORMAL: 'default',
  ALERT: 'alert',
  EXPIRED: 'expired'
};
